import { render, staticRenderFns } from "./userViewModelIfram.vue?vue&type=template&id=1d0494b2&scoped=true"
import script from "./userViewModelIfram.vue?vue&type=script&lang=js"
export * from "./userViewModelIfram.vue?vue&type=script&lang=js"
import style0 from "./userViewModelIfram.vue?vue&type=style&index=0&id=1d0494b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0494b2",
  null
  
)

export default component.exports